<template>
    <Component
        :is="display"
        v-bind="props"
        :available-letters="availableLetters"
    />
    <Meta title="Catalog | Price Books" :jsonLdBreadcrumbs="crumbs" description="We stock the industry's most complete inventory of commercial door hardware and security products. Search for manufacturers by name or category for pricebooks." />
</template>

<script setup>
import { computed } from "vue";
import SourcingIndex from "../../../Themes/Sourcing/Pages/Catalog/PriceBooks/Index.vue";
import MarketingIndex from "../../../Themes/Marketing/Pages/Catalog/PriceBooks/Index.vue";
import { useUser } from "@/Composables";
import { Meta } from "@/Components";
import _ from "lodash";

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode ? SourcingIndex : MarketingIndex
);

const props = defineProps({
    manufacturers: {
        type: Array,
        required: true,
    },
    tags: {
        type: Array,
        required: true,
    },
    crumbs: {
        type: Array,
        required: true,
    },
});

const availableLetters = computed(() => {
    let firstLetters = props.manufacturers?.data?.reduce(
        (acc, manufacturer) => [...acc, manufacturer.name?.charAt(0)],
        []
    );
    return _.uniq(firstLetters);
});
</script>
